export const Urls = {
    BaseURL: 'cdn-base-url',
    Domain: 'https://www.myvirtualwallet.co.uk',
    urlpath: '/s4s/cms/',

    // Page ids
    vwHomepage: 'vw-homepage', // 93
    vwHomepageTwo: '113',

    vwDashboard: 'vw-dashboard', // 92
    myStatement: 'vw-statement', // 100
    supportSummary: 'vw-support-summary', // 101
    
    vwMicroCommisioning: '162',
    addProvider: 'vw-add-provider', // 141
    myProviders: 'vw-my-providers', // 142
    myPrograms: 'vw-service-agreements', // 143
    agencyEnrolments: '143', // Making same as My programs
    myDesignatedRep: 'vw-designated-rep', // 144
    mySignatures: 'my-signature', // 145
    addDesignatedRep: 'vw-add-designated-rep', // 146
    myDetails: 'my-details', // 148
    myParticipants: 'vw-my-individuals', // 149
    servicesAndRates: '154',
    myDocuments: 'vw-my-documents', // 256
    fundingDue: 'vw-funding-due', // 261
    providerTimesheetsAdmin: 'vw-provider-timesheets', // 293
    //personalTimesheets: 'timesheets', // 297

    vwSagDash: 'admin-dashboard', // 151

    events: '391',
    eventsWizardCreatePublic: '392',
    eventsImport: '393',

    searchShopEquipment: 'vw-marketplace-equipment', // 168
    searchShopServices: 'vw-marketplace-services', // 169
    searchMyCatalogue: 'vw-marketplace-catalogue', // 170
    searchShopStores: 'vw-marketplace-stores', // 171

    manualPayment: 'vw-manual-transactions', // 205
    managePayee: 'vw-manage-payees', // 206
    paymentTransfer: 'vw-payment-transfers', // 207
    providerDetails: 'vw-provider-details', // 211
    manualTransactionPayments: 'vw-payment-approvals', // 221

    vwLitePageId: '178',
    vwLiteProductId: '195',

    pplConnectPage: 'ppl-connect', // 311
    pa_vacancySearchPage: 'vw-pa-search', // 312
    pplChat: 'ppl-chat', // 313
    reportsPage: 'bi-reports', // 347
    
    vwliteCouncil: 'NHS Hull CCG',

    manualTransactionPaymentApproval: '221',

    incrementsAttribute: 'Increments',

    // Attributes
    allowSelfServicePayment: 'c4081c76-9a24-4cc1-8e7f-aeec00fad56c',

    // Form ids
    form_nwl: '971',
    form_essex: '823',
    form_croydon: '824',
    form_bucks: '825',
    form_powys: '850',
    form_CheshireCCG: '972',
    form_vwLite: '967',
    form_lincs: '1037',
    form_hull: '967',
    form_devon: '1016',
    form_dorset: '1017',
    form_wiltshire: '1024',
    form_kentMedway: '1025',
    form_budgetCalculator: '836',
    attachments_appForm: '645289962a39462df7500db4',
    
    virtualWalletLiteSecurityGroup: 'bb6cf2af-029a-4cc6-b81b-ae4700ca4ff4',
    providerDetailsSecurityGroup: 'd3565417-134a-46c5-ac34-ab4c00a1b939',
    addPayeeSecurityGroup: '1c2d283f-0a85-4054-80fa-b00b01229ce5',
    approverSecurityGroup: '3d77e404-6da7-40c6-bd36-b02300e40c4d',
    readOnlySecurityGroup: 'e8bc9297-105c-4ec4-b6f2-b1b60113df5e',
    pdfSecurityGroup: '0977d6d1-6301-4a9a-9e9e-b2e300b08967',

    manualTransactionSecurityGroups: {
        mt_Payment: '1f181521-7821-47ca-b97a-afa400bb0ab4',
        mt_Repeating: '14077b13-5a1b-46a4-91de-afa400c174ba',
        mt_attachment: '9d0b965f-f2e3-48c7-8577-af8f00e8fa1a'
    },

    permission: {
        manualTransactionPayments: '8ac87b59-4ccf-4ded-b779-8343341ef198'
    },

    // Devon marketplaces
    devonMarketplace: '52ec69f6-9a12-40a6-81bd-b10101686083'
}